export const TEACHERS = "TEACHERS";
export const TEACHERS_LOADING = "TEACHERS_LOADING";
